module.exports = __webpack_public_path__ + "static/img/f1.6c295e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ui3/f1.png
// module id = uH4O
// module chunks = 1